import { render } from "./InvoiceHead.vue?vue&type=template&id=4df0960b"
import script from "./InvoiceHead.vue?vue&type=script&lang=js"
export * from "./InvoiceHead.vue?vue&type=script&lang=js"
script.render = render

export default script